<template>
  <div class="content_box">
    <div class="content_box_inner">
      <div class="" id="ManageTable">
        <div class="headTitle" style="position: relative">
          <img src="@/assets/imgs/icon/icon_my_company.png" alt />
          我的企业
          <div class="reviseCompanyInformation" @click="showRevise">
            <i class="el-icon-edit-outline"></i>企业信息申请修改
          </div>
        </div>

        <hr />
        <div class="lineTitle MT30">基本信息</div>
        <div class="baseMsg">
          <el-row style="width: 100%">
            <el-col
              class="sinMsg"
              :xs="12"
              :lg="4"
              v-for="(item, index) in detailList"
              :key="index"
            >
              <div v-if="item.name != '“三大改造”实施'">
                <div class="name">{{ item.name }}</div>
                <div class="value">{{ item.value }}</div>
              </div>
              <div v-if="item.name == '“三大改造”实施'">
                <div class="name">{{ item.name }}</div>
                <div class="value">
                  <el-tag
                    v-for="item1 in threeChangesItem"
                    :key="item1.label"
                    :type="item1.type"
                    effect="plain"
                    >{{ item1.label }}</el-tag
                  >
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="baseMsg">
            <div class="sinMsg noBorder">
              <div class="name">公司简介</div>
              <div class="value">{{ otherInfo.companyProfile }}</div>
            </div>
          </div>
        </div>

        <hr />
        <div class="lineTitle MT60">企业平台</div>
        <div class="baseMsg">
          <div class="sinMsg noBorder">
            <div class="name">登录账号</div>
            <div class="value">{{ otherInfo.username }}</div>
          </div>
          <div class="sinMsg noBorder">
            <div class="name">是否催报</div>
            <div class="value">{{ otherInfo.isReport }}</div>
          </div>
        </div>

        <el-dialog
          title="编辑企业"
          :visible.sync="showEditWindow"
          class="dialog1021 titleChange bodyScroll"
          :width="screenWidth < 1200 ? '96%' : '60%'"
          :close-on-click-modal="false"
        >
          <div class="lineTitle">
            <span>基本信息</span>
          </div>
          <el-form
            :inline="true"
            :model="editObj"
            class="demo-form-inline half"
            size="mini"
            label-width="135px"
            label-position="right"
            ref="editForm"
            :rules="rules"
            v-loading="editLoading"
          >
            <el-row>
              <el-col :xs="24" :lg="12">
                <el-form-item label="企业名称" prop="name">
                  <el-input
                    v-model.trim="editObj.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="统一社会信用代码">
                  <el-input
                    v-model.trim="editObj.code"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="登记注册类型">
                  <el-select
                    v-model="editObj.registerType"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in registerList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="国民经济行业">
                  <el-select
                    v-model="editObj.industryType"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in industryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="注册资金（万元）">
                  <el-input
                    v-model.trim="editObj.registerMoney"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="注册时间">
                  <el-date-picker
                    v-model="editObj.registerTime"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="法定代表人">
                  <el-input
                    v-model.trim="editObj.representativePerson"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="邮政编码">
                  <el-input
                    v-model.trim="editObj.postCode"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="所在工业园区">
                  <el-select
                    v-model="editObj.park"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      label="不在园区内"
                      value="不在园区内"
                    ></el-option>
                    <el-option
                      v-for="item in parkList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="是否规上">
                  <el-select
                    v-model="editObj.aboveScale"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="是否上市">
                  <el-select
                    v-model="editObj.listed"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="是否军工">
                  <el-select
                    v-model="editObj.military"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="企业规模">
                  <el-select
                    v-model="editObj.companySize"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="大型" value="大型"></el-option>
                    <el-option label="中型" value="中型"></el-option>
                    <el-option label="小型" value="小型"></el-option>
                    <el-option label="微型" value="微型"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="企业类别">
                  <el-select
                    v-model="editObj.companyCategory"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="50户重点" value="50户重点"></el-option>
                    <el-option label="小巨人" value="小巨人"></el-option>
                    <el-option label="专精特新" value="专精特新"></el-option>
                    <el-option label="隐形冠军" value="隐形冠军"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="企业性质">
                  <el-select
                    v-model="editObj.companyNature"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="国有" value="国有"></el-option>
                    <el-option label="民营" value="民营"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="“565”产业">
                  <el-cascader
                    v-model="editObj.company565"
                    :options="Company565List"
                    :props="deftProps"
                    clearable
                    placeholder="请选择"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="是否10亿元">
                  <el-select
                    v-model="editObj.oneBillion"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="提质倍增">
                  <el-select
                    v-model="editObj.multiplication"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="市级" value="市级"></el-option>
                    <el-option label="区县级" value="区县级"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="是否店小二服务">
                  <el-select
                    v-model="editObj.xiaoerService"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="“三大改造”实施">
                  <el-select
                    v-model="editObj.threeChanges"
                    multiple
                    placeholder="请选择"
                  >
                    <el-option
                      label="智能化改造"
                      value="智能化改造"
                    ></el-option>
                    <el-option
                      label="绿色化改造"
                      value="绿色化改造"
                    ></el-option>
                    <el-option label="技术改造" value="技术改造"></el-option>
                    <el-option label="未实施" value="未实施"></el-option>
                    <el-option label="已实施" value="已实施"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="注册区县" class="selection_item">
                  <el-select
                    class="city_input_box"
                    v-model="luoyangCity"
                    :placeholder="city_name"
                    disabled
                  >
                    <el-option
                      :label="city_name"
                      :value="city_name"
                    ></el-option>
                  </el-select>
                  <el-select
                    class="city_input_box"
                    v-model="editObj.district"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in seatList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="注册地址">
                  <el-input
                    v-model.trim="editObj.registerAddress"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="24">
                <el-form-item label="办公地址">
                  <el-input
                    v-model.trim="editObj.officeAddress"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="24">
                <el-form-item label="公司简介" prop="companyProfile">
                  <el-input
                    class="address_input_box"
                    type="textarea"
                    v-model="editObj.companyProfile"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="24">
                <el-form-item label="申请原因" prop="reason">
                  <el-input
                    class="address_input_box"
                    type="textarea"
                    v-model="editObj.reason"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <hr style="width: 100%; margin: 30px 0" />
            <div class="lineTitle" style="width: 100%">联系信息</div>
            <el-row>
              <el-col :xs="24" :lg="12">
                <el-form-item label="联系邮箱">
                  <el-input
                    v-model.trim="editObj.companyEmail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="法定代表人电话">
                  <el-input
                    v-model.trim="editObj.representativePhone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="联系人姓名">
                  <el-input
                    v-model.trim="editObj.contactName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="联系人职务">
                  <el-input
                    v-model.trim="editObj.contactPosition"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="联系手机" prop="contactPhone">
                  <el-input
                    v-model.trim="editObj.contactPhone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <el-form-item label="联系座机">
                  <el-input
                    v-model.trim="editObj.contactLandlinePhone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item style="width: 100%">
              <div class="btnBox">
                <el-button
                  type="primary"
                  size="mini"
                  class="bg5584FF"
                  @click="sureDraft('editForm')"
                  >存为草稿</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  class="bg5584FF"
                  @click="sureEdit('editForm')"
                  >提交</el-button
                >
                <el-button
                  type="normal"
                  size="mini"
                  @click="showEditWindow = false"
                  >取消</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { mapGetters } from "vuex";

export default {
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!value) {
        callback();
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    var onlyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入统一社会信用代码"));
      } else {
        this.$axios
          .get(`/business/company/selectByCode/${value}`)
          .then((res) => {
            if (res.data >= 1) {
              callback(new Error("统一社会信用代码已存在"));
            } else if (res.data == 0) {
              callback();
            }
          });
      }
    };
    var checkLength = (rule, value, callback) => {
      if (value.length > 150) {
        callback(
          new Error("输入长度限制为150字符，当前输入长度" + value.length)
        );
      } else {
        callback();
      }
    };
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      showEditWindow: false,
      threeChangesItem: [],
      zdyItems: [],
      otherInfo: {
        zdyname: "",
        isReport: "",
        username: "",
        companyProfile: "",
      },
      detailList: [
        {
          name: "企业名称",
          code: "",
          value: "",
        },
        {
          name: "统一社会信用代码",
          code: "",
          value: "",
        },
        {
          name: "企业登记注册类型",
          code: "",
          value: "",
        },
        {
          name: "国民经济行业类型",
          code: "",
          value: "",
        },
        {
          name: "企业注册资金（万元）",
          code: "",
          value: "",
        },
        {
          name: "注册时间",
          code: "",
          value: "",
        },
        {
          name: "法定代表人",
          code: "",
          value: "",
        },
        {
          name: "邮政编码",
          code: "",
          value: "",
        },
        {
          name: "所属园区",
          code: "",
          value: "",
        },
        {
          name: "是否规上",
          code: "",
          value: "",
        },
        {
          name: "是否上市企业",
          code: "",
          value: "",
        },
        {
          name: "是否军工企业",
          code: "",
          value: "",
        },
        {
          name: "企业规模",
          code: "",
          value: "",
        },
        {
          name: "企业类别",
          code: "",
          value: "",
        },
        {
          name: "企业性质",
          code: "",
          value: "",
        },

        {
          name: "565产业",
          code: "",
          value: "",
        },
        {
          name: "是否超十亿",
          code: "",
          value: "",
        },
        {
          name: "提质倍增",
          code: "",
          value: "",
        },
        {
          name: "是否店小二服务",
          code: "",
          value: "",
        },
        {
          name: "“三大改造”实施",
          code: "",
          value: "",
        },
        {
          name: "注册区（市）县",
          code: "",
          value: "",
        },
        {
          name: "企业注册地址",
          code: "",
          value: "",
        },
        {
          name: "企业办公地址",
          code: "",
          value: "",
        },

        {
          name: "联系邮箱",
          code: "",
          value: "",
        },
        {
          name: "法定代表人电话",
          code: "",
          value: "",
        },
        {
          name: "企业联系人",
          code: "",
          value: "",
        },
        {
          name: "企业联系人职务",
          code: "",
          value: "",
        },
        {
          name: "联系电话（手机）",
          code: "",
          value: "",
        },
        {
          name: "联系电话（座机）",
          code: "",
          value: "",
        },
      ],
      detailComList: [
        {
          name: "企业编号",
          code: "",
          value: "",
        },
        {
          name: "登陆账号",
          code: "",
          value: "",
        },
        {
          name: "是否催报",
          code: "",
          value: "",
        },
        {
          name: "启用状态",
          code: "",
          value: "",
        },
        {
          name: "企业属性分类",
          code: "",
          value: "",
        },
        {
          name: "主管部门",
          code: "",
          value: "",
        },
      ],
      editLoading: false,
      rules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        code: [{ required: true, validator: onlyCode, trigger: "blur" }],
        contactPhone: [
          { required: false, validator: checkPhone, trigger: "blur" },
        ],
        district: [
          { required: true, message: "请选择注册区县", trigger: "change" },
        ],
        registerType: [
          {
            required: true,
            message: "请选择登记注册类型，若没有请选择无",
            trigger: "change",
          },
        ],
        industryType: [
          {
            required: true,
            message: "请选择国民经济行业，若没有请选择无",
            trigger: "change",
          },
        ],
        companyProfile: [{ validator: checkLength, trigger: "change" }],
      },
      editObj: {
        id: "",
        name: "", //企业名称
        code: "", //统一社会信用代码
        registerType: "",
        industryType: "",
        registerMoney: "",
        registerTime: "",
        representativePerson: "",
        postCode: "",
        park: "",
        aboveScale: "",
        listed: "",
        military: "",
        companySize: "",
        companyCategory: "",
        companyNature: "",
        company565: "",
        oneBillion: "",
        multiplication: "",
        xiaoerService: "",
        threeChanges: "",
        district: "",
        registerAddress: "",
        officeAddress: "",
        companyProfile: "",
        companyEmail: "",
        representativePhone: "",
        contactName: "",
        contactPosition: "",
        contactPhone: "",
        contactLandlinePhone: "",
      },
      parkList: [],
      industryList: [],
      registerList: [],
      Company565List: [],
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      luoyangCity: "",
      city_name: "",
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },

  methods: {
    //提交
    sureEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editObj.threeChanges = JSON.stringify(this.editObj.threeChanges);
          if (
            this.editObj.company565 != "" &&
            typeof this.editObj.company565 != "string"
          ) {
            this.editObj.company565 = this.editObj.company565[1];
          }
          this.editObj.refid = this.editObj.id;
          this.editObj.id = null;
          this.editObj.updateStatus = 1;
          this.$axios
            .put("/business/updateCompanyEdit", this.editObj)
            .then((res) => {
              if (res.code == 400) {
                this.showEditWindow = false;
              }
              this.editLoading = false;
              this.showEditWindow = false;
              for (const key in this.editObj) {
                this.editObj[key] = "";
              }
              this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
            })
            .catch(() => {
              this.editLoading = false;
              this.showEditWindow = false;
            });
        } else {
          return false;
        }
      });
    },
    //存为草稿
    sureDraft(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editObj.threeChanges = JSON.stringify(this.editObj.threeChanges);
          if (
            this.editObj.company565 != "" &&
            typeof this.editObj.company565 != "string"
          ) {
            this.editObj.company565 = this.editObj.company565[1];
          }
          this.editObj.refid = this.editObj.id;
          this.editObj.id = null;
          this.editObj.updateStatus = 0;
          this.$axios
            .put("/business/updateCompanyEdit", this.editObj)
            .then((res) => {
              this.editLoading = false;
              this.showEditWindow = false;
              for (const key in this.editObj) {
                this.editObj[key] = "";
              }
              this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
            })
            .catch(() => {
              this.editLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    showRevise() {
      this.$axios
        .get(`/business/selectByCompanyId?refId=${this.vId}`)
        .then((res) => {
          this.editObj = res.data.data;
          this.showEditWindow = true;
          this.getSelectList();
        });
    },
    getSelectList() {
      //获取下拉列表
      // 园区列表
      this.$axios.get("/business/park/selectParkNames").then((res) => {
        this.parkList = res.data;
      });
      // 国民经济行业列表
      this.$axios
        .get("/business/dm/hy/tree", {
          params: {
            parent_code: -1,
            is_select: 0,
          },
        })
        .then((res) => {
          this.industryList = res.data;
        });
      // 登记注册类型
      this.$axios.get("/business/company/selectRegisterType").then((res) => {
        this.registerList = res.data;
      });
      //565列表
      this.$axios.get("/business/company/selectCompany565List").then((res) => {
        this.Company565List = res.data;
      });
      //获取报表
    },

    getData() {
      this.$axios
        .get("/business/myCompany/selectCompany")
        .then((res) => {
          this.vId = res.data.id;
          this.detailList[0].value = res.data.name;
          this.detailList[1].value = res.data.code;
          this.detailList[2].value = res.data.registerType;
          this.detailList[3].value = res.data.industryType;
          this.detailList[4].value = res.data.registerMoney;
          this.detailList[5].value = res.data.registerTime.slice(0, 10);
          this.detailList[6].value = res.data.representativePerson;
          this.detailList[7].value = res.data.postCode;
          this.detailList[8].value = res.data.park;
          this.detailList[9].value = res.data.aboveScale;
          this.detailList[10].value = res.data.listed;
          this.detailList[11].value = res.data.military;
          this.detailList[12].value = res.data.companySize;
          this.detailList[13].value = res.data.companyCategory;
          this.detailList[14].value = res.data.companyNature;
          this.detailList[15].value = res.data.company565;
          this.detailList[16].value = res.data.oneBillion;
          this.detailList[17].value = res.data.multiplication;
          this.detailList[18].value = res.data.xiaoerService;
          this.detailList[19].value = res.data.threeChanges;
          var items = eval(res.data.threeChanges);
          for (let i = 0; i < items.length; i++) {
            this.threeChangesItem.push({
              type: "info",
              label: items[i],
            });
          }
          this.detailList[20].value = res.data.district;
          this.detailList[21].value = res.data.registerAddress;
          this.detailList[22].value = res.data.officeAddress;
          this.detailList[23].value = res.data.companyEmail;
          this.detailList[24].value = res.data.representativePhone;
          this.detailList[25].value = res.data.contactName;
          this.detailList[26].value = res.data.contactPosition;
          this.detailList[27].value = res.data.contactPhone;
          this.detailList[28].value = res.data.contactLandlinePhone;

          this.otherInfo.companyProfile = res.data.companyProfile;
          if (res.data.zdyname != null) {
            var zdy = eval(res.data.zdyname);
            for (let i = 0; i < zdy.length; i++) {
              this.zdyItems.push({
                type: "info",
                label: zdy[i],
              });
            }
          }

          this.otherInfo.isReport = res.data.isReport;
        })
        .catch(() => {
          console.log("error");
        });
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    var str = document.cookie.replace(/\s+/g, "");
    var user = str.split(";");
    for (let i = 0; i < user.length; i++) {
      if (user[i].search("userName") == 0) {
        var admin = user[i].split("userName=");
        this.otherInfo.username = admin[1];
      }
    }

    this.getData();
    if (this.seatList1.length) {
      this.city_name = this.seatList1[0];
      console.log(this.city_name);
    }
  },
};
</script>

<style lang="less" scoped>
hr {
  margin: 25px 0 35px;
  border-color: rgba(155, 155, 155, 0.2);
}

.baseMsg {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  img {
    width: 500px;
    height: 360px;
  }

  .sinMsg {
    // width: 16%;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);

    .name {
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 10px;
    }

    .value {
      font-size: 16px;
      font-weight: 700;
      color: rgba(51, 51, 51, 1);
      min-height: 42px;
    }
  }

  .sinMsg:last-child {
    flex: 1;
  }

  .part_1 {
    display: flex;
    flex-wrap: wrap;
    width: 1050px;

    .sinMsg {
      width: 25%;
    }
  }
}

.noBorder {
  border: 0 !important;
}

.reviseCompanyInformation {
  position: absolute;
  top: 4px;
  left: 150px;
  padding: 5px 10px;
  background-color: darkgrey;
  font-size: 12px;
  margin-left: 40px;
  cursor: pointer;
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>